export class RetrievalResponse {
    constructor() {
        this.results = [];
    }
}
export class Retrieval {
    constructor() {
        this.query = "";
        this.results = [];
    }
}
export class RetrievalItem {
    constructor() {
        this.id = "";
        this.text = "";
    }
}
export class RetrievalItemMetaData {
    constructor() {
        this.document_id = "";
    }
}
